export enum ActionItems {
    KYC_VERIFICATION = 1,
    ENABLE_FOR_ALL_EMPLOYEES = 2
}